var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const FlagEnd = (_a) => {
    var { color = '#65C702', fill = 'none', width = 22, height = 32 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M20.1991 15.0255L18.3898 13.2509C17.9597 12.8873 17.7076 12.3491 17.6928 11.7527C17.6631 11.0982 17.9301 10.4436 18.4195 9.96364L20.1991 8.21818C21.7415 6.70545 22.3199 5.25091 21.8305 4.10182C21.3559 2.96727 19.8877 2.34182 17.7224 2.34182H2.22457V1.09091C2.22457 0.494545 1.72034 0 1.11229 0C0.504237 0 0 0.494545 0 1.09091V30.9091C0 31.5055 0.504237 32 1.11229 32C1.72034 32 2.22457 31.5055 2.22457 30.9091V20.9018H17.7224C19.858 20.9018 21.2966 20.2618 21.786 19.1127C22.2754 17.9636 21.7119 16.5236 20.1991 15.0255Z", fill: "#65C702" })));
};
export default FlagEnd;
